/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Pagination_PreviousInputs */

const en_clients_pagination_previous = /** @type {(inputs: Clients_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const pt_br2_clients_pagination_previous = /** @type {(inputs: Clients_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Clients_Pagination_PreviousInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_pagination_previous = /** @type {((inputs?: Clients_Pagination_PreviousInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Pagination_PreviousInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_pagination_previous(inputs)
	return pt_br2_clients_pagination_previous(inputs)
});